import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Card, Container, Tabs, Tab, Box } from '@mui/material';
import ImmersveKycTable from './immersve/ImmersveKycTable';
import IdentomatKYCTable from './identomat/IdentomatKYCTable';
import Page from '../../../../components/Page';
import HeaderBreadcrumbs from '../../../../components/HeaderBreadcrumbs';
import { PATH_AFTER_LOGIN } from '../../../../config';
import useSettings from '../../../../hooks/useSettings';

const RetailKyc = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const tab = query.get('tab');
  const { themeStretch } = useSettings();
  const title = tab === 'immersve' ? 'Immersve KYC: List' : 'Retail KYC: List';
  const heading = tab === 'immersve' ? 'Immersve KYC' : 'Retail KYC';
  const [value, setValue] = React.useState(tab || 'identomat');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Page title={title}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs heading={heading} links={[{ name: 'Accounts', href: PATH_AFTER_LOGIN }, { name: 'List' }]} />
        <Card>
          <Box sx={{ margin: '20px 24px' }}>
            <Tabs value={value} onChange={handleChange}>
              <Tab label="Identomat KYC" value="identomat" component={Link} to="/account/retail-kyc/?tab=identomat" />
              <Tab label="Immersve KYC" value="immersve" component={Link} to="/account/retail-kyc/?tab=immersve" />
            </Tabs>
          </Box>

          {value === 'immersve' ? <ImmersveKycTable /> : <IdentomatKYCTable />}
        </Card>
      </Container>
    </Page>
  );
};

export default RetailKyc;
